import { UserBehaviorRisksAppNirvanaDataProvider } from '../dataProvider/UserBehaviorRisksAppNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class UserBehaviorRisksAppDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, UserBehaviorRisksAppNirvanaDataProvider);
  }
}
